import React, { useState } from 'react';
import cn from 'classnames';

import { useTranslation, useResponsive, useAppSelector, useOnClickOutside } from 'client/hooks';
import { selectOccupancy, selectSignedUsersOccupancy } from 'client/redux/pubnub/selectors';
import { thousandSeparator } from 'utils/thousand-separator';

import Icon from '../../../Icon';

import css from './UsersStatisticsButton.module.scss';

interface Props {
  className?: string;
  statisticDrawerState: (state: boolean) => void;
}

const UsersStatisticsDrawer: React.FC<Props> = (props) => {
  const { className = '', statisticDrawerState } = props;
  const counterIncognito = useAppSelector(selectOccupancy);
  const counterLogedIn = useAppSelector(selectSignedUsersOccupancy);
  const counter = counterIncognito + counterLogedIn;
  const { translate } = useTranslation('actionsPanel');
  const [isActiveStatistic, setIsActiveStatistic] = useState<boolean>(false);
  const [isMobile] = useResponsive('MOBILE');
  const statisticBtnRef = React.useRef<HTMLDivElement>(null);

  const clickOnBtn = () => {
    setIsActiveStatistic(!isActiveStatistic);
    if (isActiveStatistic) {
      statisticDrawerState(false);
    } else {
      statisticDrawerState(true);
    }
  };

  const closeList = () => {
    if (isActiveStatistic) {
      setIsActiveStatistic(false);
      statisticDrawerState(false);
    }
  };

  useOnClickOutside<HTMLDivElement>(statisticBtnRef, closeList);

  return (
    <div
      className={cn(css.usersStatisticButton, className)}
      ref={statisticBtnRef}
      data-testid="user-statistic-btn-container"
    >
      <div className={css.btn} onClick={clickOnBtn} data-testid="user-statistic-btn">
        <div className={cn(css.iconWrapper)}>
          <Icon type="participants" className={cn(css.icon, isActiveStatistic && css.active)} />
        </div>
        <div className={css.name}>
          {translate('btns.usersStatisticBtn')}
          &nbsp;{!isMobile && counter > 0 && <>({thousandSeparator(counter)})</>}
        </div>
        {<div className={css.counter}>{isMobile && counter > 0 && `(${thousandSeparator(counter)})`}&#8205;</div>}
      </div>
    </div>
  );
};

export default UsersStatisticsDrawer;
